// ADR 7.10.26w §5 — slot 0: two tabs, while both surfaces are open beside two pages.
//
// Named by v's `spread_companion_label` ("Side page"), not
// `header_switcher_label`, which already names `HeaderSwitcher` and is on
// screen at the same time. The tabs are `tutor_sheet_title` and the install's
// own name, so w adds no locale key. Since ADR 16.10.26k §2 the arrow keys,
// Home and End (automatic activation) are `ui/controls/Tabs`'; a press that
// changes the front still emits `web_companion_switched` here, with no app id
// or name.

import { useTranslation } from 'react-i18next'

import { Tabs } from '../../ui/controls'
import { useAppCardState } from '../apps/sheet/AppCardProvider'
import type { Front } from './companionFront'
import { useCompanion } from './CompanionProviders'
import { companionSwitched } from './companionTelemetry'

export type SwitcherIds = Record<Front, { tab: string; panel: string }>

const ORDER: Front[] = ['tutor', 'app_card']

export function CompanionSwitcher({ ids }: { ids: SwitcherIds }) {
  const { t } = useTranslation()
  const { front, switchTo } = useCompanion()
  const { open } = useAppCardState()
  const label: Record<Front, string> = { tutor: t('tutor_sheet_title'), app_card: open?.install.name ?? '' }
  const items = ORDER.map((tab) => ({ value: tab, label: label[tab], id: ids[tab].tab, panelId: ids[tab].panel }))

  const pick = (to: Front) => {
    if (to === front) return
    switchTo(to)
    companionSwitched(to)
  }

  return (
    <div className="mb-2">
      <Tabs label={t('spread_companion_label')} items={items} selected={front} onSelect={pick} />
    </div>
  )
}
